import React, { useCallback, useState } from "react";
import { SlidersHorizontal, X } from "lucide-react";
import ParameterNameField from "./ParameterNameField";
import ParameterValueField from "./ParameterValueField";
import { usePopupLifecycle } from "../../view/popup/usePopupLifecycle";

function CreateParameterPopup({ closePopup, confirm }) {

    const [parameterValue, setValue] = useState('');
    const [parameterName, setName] = useState('');

    const handleClose = useCallback(() => closePopup(), [closePopup]);
    usePopupLifecycle(handleClose);

    const onSaveClick = () => {
        closePopup();
        confirm(parameterName, parameterValue);
    };

    return (
        <div className="oct-shared-popup" role="dialog" aria-modal="true" aria-labelledby="oct-create-parameter-title">
            <div className="oct-shared-popup__backdrop" onClick={handleClose} />

            <div className="oct-shared-popup__dialog oct-shared-popup__dialog--compact" onClick={(event) => event.stopPropagation()}>
                <div className="oct-shared-popup__header">
                    <div className="oct-shared-popup__title-wrap">
                        <div className="oct-shared-popup__title-icon">
                            <SlidersHorizontal size={18} />
                        </div>
                        <div>
                            <h4 id="oct-create-parameter-title" className="oct-shared-popup__title">Create Parameter</h4>
                            <p className="oct-shared-popup__subtitle">Add a reusable parameter for rule scripts and expected output.</p>
                        </div>
                    </div>

                    <button type="button" className="oct-shared-popup__close" onClick={handleClose} aria-label="Close create parameter popup">
                        <X size={18} />
                    </button>
                </div>

                <div className="oct-shared-popup__body oct-shared-popup__body--form">
                    <ParameterNameField value={parameterName} onChange={(value) => setName(value)} />
                    <ParameterValueField value={parameterValue} onChange={(value) => setValue(value)} />
                </div>

                <div className="oct-shared-popup__footer oct-shared-popup__footer--end">
                    <button type="button" className="btn oct-shared-popup__btn oct-shared-popup__btn--secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn oct-shared-popup__btn oct-shared-popup__btn--primary"
                        disabled={!parameterName || !parameterValue}
                        onClick={onSaveClick}
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    )

}

export default CreateParameterPopup;
